import { Row, Typography } from 'antd';
import Paragraph from 'antd/lib/typography/Paragraph';
import React, { useEffect, useState } from 'react';
import ServiceData from "../../../Assets/JsonData/ServiceData.json";
import ServiceItem from './ServiceItem';

const { Title } = Typography;

const Service = () => {
    const [services, setServices] = useState(ServiceData)
    useEffect(() => {
        setServices(services)
    }, [services])

    return (
        <>
            <div style={{ padding: '5rem 0', textAlign: 'center' ,backgroundColor: '#112240'}}>
                <Title level={3} style={{ color: '#FFF' }}>My Services</Title>
                <Paragraph level={5} style={{ color: '#FFF' ,textTransform: 'uppercase' }}>"The two most important days in your life are the day you are born and the day you find out why"</Paragraph>
            </div>

            <Row justify="center" style={{padding:'4rem 0'}}>
                {services.map(service => <ServiceItem service={service} key={service.id} />)}
            </Row>

        </>
    );
};

export default Service;